import { ReactElement, useEffect } from 'react'
import FloatingMessage from './FloatingMessage'
import styled from 'styled-components'
import { Check } from '@mui/icons-material'
import { defaultTheme } from '../../../../../../src/theme/index'
import { I18n, Translate } from 'common'
import { observer } from 'mobx-react-lite'
import { useResultsStore } from '../../../store/ResultsStore'
import { Hyperlink } from '../../../../../../src/ui-components/util/Hyperlink'
import { StoreInstances } from '../../../../../../src/store/StoreInstancesContainer'

/* 
  Due to an API limitation, the interchange search (Non-cached search only)
  doesn't support sorting by Cost, Availability or List and thus the user has to manually
  click a sort option after results are loaded
*/
const ReadyMessage = observer((): ReactElement => {
  const resultsStore = useResultsStore()
  const title = Translate('resultsLoaded')
  const visible = StoreInstances.uiStore.showApplySortMessage

  const notSupported = (i) =>
    i.label?.includes('Cost') ||
    i.label?.includes('Availability') ||
    i.label?.includes('List')

  const showSortMessage =
    resultsStore.sortOrder?.filter(notSupported)?.length > 0

  const sortHasNotYetBeenApplied = <I18n name="sortHasNotYetBeenApplied" />

  const handleApplySort = (): void => {
    resultsStore.applyInterchangeSearchSort()
    StoreInstances.uiStore.showApplySortMessage = false
  }

  const message = showSortMessage ? (
    <div>
      <div>{sortHasNotYetBeenApplied}</div>
      <Links>
        <Hyperlink action={handleApplySort}>
          <I18n name="applySort" />
        </Hyperlink>
      </Links>
    </div>
  ) : null

  const icon = (
    <Circle>
      <Icon />
    </Circle>
  )

  const autoHideMessage = async (delay = 3000): Promise<void> => {
    await new Promise((resolve) => setTimeout(resolve, delay))
    StoreInstances.uiStore.showApplySortMessage = false
  }

  useEffect(() => {
    if (!showSortMessage && visible) autoHideMessage()
  }, [showSortMessage, visible])

  return (
    <FloatingMessage
      title={title}
      message={message}
      icon={icon}
      visible={visible}
    />
  )
})

const Icon = styled(Check)`
  font-size: 2.5rem;
  color: ${defaultTheme.colors.white};
`

const Circle = styled.div`
  border-radius: 50%;
  background-color: ${defaultTheme.colors.green};
`

const Links = styled.div`
  display: flex;
  gap: 10px;
  text-transform: capitalize;
`

export default ReadyMessage
